import { BaseStorage } from '../base-storage';
import { verifyConsentPolicy, } from '../consent-policy';
import { KEY_SEPARATOR, LOCAL_STORAGE_UNSUPPORTED, NOT_FOUND, PREFIX_SEPARATOR, STORAGE_PREFIX, } from '../utils/constants';
import { localStorageCleaner } from '../utils/local-storage-cleaner';
import { deserializeData, getCacheRecords, isExpired, } from '../utils/record-utils';
export class LocalStorageStrategy extends BaseStorage {
    async setItem(key, value, options) {
        const serializedKey = getCacheKey(key, options);
        const serializedValue = serializeData(value, options);
        // not mandatory, yet (gradual enforcement)
        if (options.category) {
            verifyConsentPolicy(options.category);
        }
        try {
            localStorage.setItem(serializedKey, serializedValue);
        }
        catch (e) {
            localStorageCleaner(serializedKey.length + serializedValue.length);
            localStorage.setItem(serializedKey, serializedValue);
        }
    }
    getItem(key, options) {
        const fullKey = getCacheKey(key, options);
        let data;
        try {
            data = localStorage.getItem(fullKey);
        }
        catch (e) {
            return Promise.reject(LOCAL_STORAGE_UNSUPPORTED);
        }
        data = data && deserializeData(data);
        if (data && !isExpired(data)) {
            updateAccessTime(fullKey, data);
            return Promise.resolve(data.value);
        }
        else {
            return Promise.reject(NOT_FOUND);
        }
    }
    removeItem(key, options) {
        key = getCacheKey(key, options);
        localStorage.removeItem(key);
        return Promise.resolve();
    }
    getAllItems(options) {
        const prefix = getCachePrefix(options);
        const items = {};
        getCacheRecords(prefix).forEach((record) => {
            if (!isExpired(record)) {
                items[record.key] = record.value;
            }
        });
        return Promise.resolve(items);
    }
}
function getCacheKey(key, options) {
    return getCachePrefix(options) + key;
}
function stringify(obj) {
    return typeof obj === 'string' ? obj : JSON.stringify(obj);
}
function getCachePrefix(options) {
    return ([STORAGE_PREFIX, options.namespace, stringify(options.scope)]
        .filter((x) => x)
        .join(PREFIX_SEPARATOR) + KEY_SEPARATOR);
}
function serializeData(value, options) {
    const data = {
        lastUsed: Date.now(),
        createdAt: options.createdAt || Date.now(),
        expiration: options.expiration,
        value,
    };
    return JSON.stringify(data);
}
function updateAccessTime(fullKey, data) {
    const { expiration, createdAt } = data;
    localStorage.setItem(fullKey, serializeData(data.value, { expiration, createdAt }));
}
//# sourceMappingURL=local-storage.js.map